import React from 'react';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { App_PortalFragment } from '../generated.graphql';
import { getContinueShoppingUrl } from 'rental/steps/cart/resolvers';


interface Props {
  portal?: App_PortalFragment
}

export const PageNotFound = ({portal}: Props) => {
  const continueShoppingUrl = portal ? getContinueShoppingUrl({portal}) : null;
  return (
    <PageContainer>
      <RentalPageTitleHelmet>Page not found (404)</RentalPageTitleHelmet>
      <div className="py-5 text-center">
        <div className="pb-3">Page not found (404)</div>
        {portal && continueShoppingUrl &&
          <div className="">
            <a href={continueShoppingUrl} className="btn btn-primary">Add Item</a>
          </div>
        }
      </div>
    </PageContainer>
  )
};


